<title direction="left" [style]="{ 'font-size': '16px', color: '#3376F6' }">
  Étape 02 : constitution du portefeuille.
</title>
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    @if (error && derrors) {
      <info [option]="optionInfo1">
        {{ error.message }}
      </info>
    }
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        <ng-container [formGroup]="product">
          <ng-container formGroupName="parameters">
            <investissement-support
              [derrors]="derrors"
            ></investissement-support>
          </ng-container>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
